
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { ROLES } from '@/utils/constants';
import StandardModal from '@/components/shared/suites/StandardModal.vue';
import SelectComponent from '@/components/shared/Select.vue';

@Component<UserFiltersModal>({
	components: {
		StandardModal,
		SelectComponent
	}
})
export default class UserFiltersModal extends Vue {
	@Getter('getRoleLevel', { namespace: 'auth' }) private roleLevel!: number;
	@Prop({ type: Boolean, default: false }) private showModal!: boolean;
	@Prop({ type: Array, default: () => [] }) private selectedRoles!: string[];

	private mutableSelectedRoles: string[] = [...this.selectedRoles];

	private get roleOptions(): { text: string; value: string }[] {
		return Object.keys(ROLES)
			// Admins can filter by any role; everyone else only sees roles strictly less privileged than their own
			.filter(role => this.roleLevel === ROLES.admin || ROLES[role as keyof Roles] > this.roleLevel)
			.map(role => ({
				text: this.$t(`multi_location_settings.user_management.roles.${role}`),
				value: role
			}));
	}

	private get applyButtonText(): string {
		const rolesCounts = this.mutableSelectedRoles.length;
		return this.$t('multi_location_settings.user_management.filters.apply')
			+ (rolesCounts ? ` (${rolesCounts})` : '');
	}

	private applyFilters(): void {
		this.$emit('apply', [...this.mutableSelectedRoles]);
	}

	private resetFilters(): void {
		this.mutableSelectedRoles = [];
		this.$emit('apply', []);
	}
}
